var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { LazyLinkApi } from './apis/lazy-link-api.interface';
import _ from 'lodash';
let LazyLinkSignatureRepositoryImpl = class LazyLinkSignatureRepositoryImpl {
    constructor(_lazyLinkApi) {
        this._lazyLinkApi = _lazyLinkApi;
    }
    getPatentSignatureData(patentIds, folderId) {
        return this._lazyLinkApi.getPatentSignatureApi(patentIds, folderId).then(res => {
            return _.mapValues(res, (item) => {
                return {
                    ..._.pick(item, ['date', 'expire', 'from', 'shareId', 'signature', 'version']),
                };
            });
        });
    }
};
LazyLinkSignatureRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(LazyLinkApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof LazyLinkApi !== "undefined" && LazyLinkApi) === "function" ? _a : Object])
], LazyLinkSignatureRepositoryImpl);
export { LazyLinkSignatureRepositoryImpl };
